import type { AnnotationShape } from '@/features/comment-on-file';

interface Options {
  focused?: boolean;
  halo?: boolean;
}

const WIDTHS: Record<AnnotationShape['type'], [base: number, focused: number, halo: number]> = {
  pen: [2, 3, 8],
  circle: [2, 3, 8],
  rectangle: [2, 3, 8],
  arrow: [2, 3, 8],
  'text-highlight': [0, 0, 0],
};

export function strokeWidthFor(type: AnnotationShape['type'], opts: Options = {}): number {
  const [base, focused, halo] = WIDTHS[type];
  if (opts.halo) return halo;
  if (opts.focused) return focused;
  return base;
}
